import React from 'react';
import { SpotlightHeroStyles } from './SpotlightHeroStyles';

const LPHero = ({
  title,
  copy,
  backgroundImage,
  image
}) => {

  return (
    <SpotlightHeroStyles background={backgroundImage.url}>
      <div className="container">
        <div className="content">
          <h1 className="title">{title}</h1>
          <div className="copy"
            dangerouslySetInnerHTML={{
              __html: copy,
            }}></div>
        </div>
        <img class="featured" src={image} alt="featured" width="500px" height="500px" />
      </div>
    </SpotlightHeroStyles>
  );
};

export default LPHero;
